import Icon from 'veui/components/Icon'
import { IconInfoCircleSolid } from 'dls-icons-vue'

Icon.register('info-circle-solid', IconInfoCircleSolid)
